<template>
  <div id="app">
    <NavBar />
    <HeroSection v-if="currentPage === 'home'" />
    <FeaturesSection v-if="currentPage === 'home'" />
    <PricingSection v-if="currentPage === 'home'" />
    <InstallGuideSection v-if="currentPage === 'install'" />
    <QuickStartSection v-if="currentPage === 'quick-start'" />
    <FooterSection />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import HeroSection from './components/HeroSection.vue'
import FeaturesSection from './components/FeaturesSection.vue'
import PricingSection from './components/PricingSection.vue'
import InstallGuideSection from './components/InstallGuideSection.vue'
import QuickStartSection from './components/QuickStartSection.vue'
import FooterSection from './components/FooterSection.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    HeroSection,
    FeaturesSection,
    PricingSection,
    InstallGuideSection,
    QuickStartSection,
    FooterSection
  },
  data() {
    return {
      currentPage: 'home'
    }
  },
  provide() {
    return {
      setCurrentPage: this.setCurrentPage
    }
  },
  methods: {
    setCurrentPage(page) {
      this.currentPage = page;
    }
  },
  mounted() {
    // 监听页面导航事件
    window.addEventListener('navigate', (event) => {
      this.currentPage = event.detail.page;
    });
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0f0f23;
  background: #fafafa;
  min-height: 100vh;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  cursor: pointer;
  min-height: 44px;
}

.btn-primary {
  background: #0f0f23;
  color: white;
  border-color: #0f0f23;
}

.btn-primary:hover {
  background: #1a1a3e;
  border-color: #1a1a3e;
  transform: translateY(-1px);
}

.btn-secondary {
  background: transparent;
  color: #0f0f23;
  border: 1px solid #e5e7eb;
}

.btn-secondary:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}
</style>
